module.exports = __webpack_public_path__ + "img/medal.bdab580c.svg";